import { useContext } from 'react';
import { StationObservationsContext, type StationObservationsContextType } from './stationObservationsTypes';

export const useStationObservations = (): StationObservationsContextType => {
  const context = useContext(StationObservationsContext);
  if (!context) {
    throw new Error('useStationObservations must be used within StationObservationsProvider');
  }
  return context;
};

